/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Important_Tax_InformationInputs */

const en_important_tax_information = /** @type {(inputs: Important_Tax_InformationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Important Tax Information`)
};

const es_important_tax_information = /** @type {(inputs: Important_Tax_InformationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Información fiscal importante`)
};

const fr_important_tax_information = /** @type {(inputs: Important_Tax_InformationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informations fiscales importantes`)
};

const de_important_tax_information = /** @type {(inputs: Important_Tax_InformationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wichtige Steuerinformationen`)
};

const ja_important_tax_information = /** @type {(inputs: Important_Tax_InformationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重要な税務情報`)
};

const zh_important_tax_information = /** @type {(inputs: Important_Tax_InformationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重要税务信息`)
};

const ar_important_tax_information = /** @type {(inputs: Important_Tax_InformationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`معلومات ضريبية هامة`)
};

const id_important_tax_information = /** @type {(inputs: Important_Tax_InformationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informasi Pajak Penting`)
};

const it_important_tax_information = /** @type {(inputs: Important_Tax_InformationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informazioni Fiscali Importanti`)
};

const ru_important_tax_information = /** @type {(inputs: Important_Tax_InformationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Важная налоговая информация`)
};

const pt_important_tax_information = /** @type {(inputs: Important_Tax_InformationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informações Fiscais Importantes`)
};

const ko_important_tax_information = /** @type {(inputs: Important_Tax_InformationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`중요한 세금 정보`)
};

/**
* | output |
* | --- |
* | "Important Tax Information" |
*
* @param {Important_Tax_InformationInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const important_tax_information = /** @type {((inputs?: Important_Tax_InformationInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Important_Tax_InformationInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_important_tax_information(inputs)
	if (locale === "es") return es_important_tax_information(inputs)
	if (locale === "fr") return fr_important_tax_information(inputs)
	if (locale === "de") return de_important_tax_information(inputs)
	if (locale === "ja") return ja_important_tax_information(inputs)
	if (locale === "zh") return zh_important_tax_information(inputs)
	if (locale === "ar") return ar_important_tax_information(inputs)
	if (locale === "id") return id_important_tax_information(inputs)
	if (locale === "it") return it_important_tax_information(inputs)
	if (locale === "ru") return ru_important_tax_information(inputs)
	if (locale === "pt") return pt_important_tax_information(inputs)
	return ko_important_tax_information(inputs)
});